import type { ButtonHTMLAttributes, Ref } from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'danger-solid' | 'irreversible'
export type ButtonSize = 'regular' | 'large'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant
  size?: ButtonSize
  pending?: boolean
  pendingLabel?: string
  ref?: Ref<HTMLButtonElement>
}

export const Button = ({
  variant = 'secondary',
  size = 'regular',
  pending = false,
  pendingLabel,
  disabled,
  children,
  className,
  type = 'button',
  ref,
  ...rest
}: ButtonProps) => (
  <button
    {...rest}
    ref={ref}
    type={type}
    className={['btn', `btn-${variant}`, `btn-${size}`, className].filter(Boolean).join(' ')}
    disabled={disabled === true || pending}
    aria-busy={pending ? 'true' : undefined}
  >
    {pending && pendingLabel !== undefined ? pendingLabel : children}
  </button>
)
